import { Table, TableBody, TableCell, TableRow, Typography } from "@mui/material";

const AddressInfoTable= ({partName , order}) => {
    return(
        <TableRow>
            <TableCell sx={{fontSize : "12px" , pl : 1 , backgroundColor : "#686868" , color : "white" , width : "32%"}}>{partName}</TableCell>
            <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell sx={{fontSize : "12px" , p:2}}>{order?.shipping_address?.Name }</TableCell>
                </TableRow>
              <TableRow>
                <TableCell sx={{fontSize : "12px" ,  p:2 }}>{order?.shipping_address?.Address}</TableCell>
                </TableRow>
              <TableRow>
                <TableCell sx={{fontSize : "12px" ,  p:2 }}>{order?.shipping_address?.City} , {order?.shipping_address?.Post_Code}</TableCell>
                </TableRow>
              <TableRow>
                <TableCell sx={{fontSize : "12px" ,  p:2 }}>{order?.shipping_address?.Country_Region_Code}</TableCell>
                </TableRow>
              <TableRow>
                <TableCell sx={{fontSize : "12px" ,  p:2  }}>T : {order?.shipping_address?.Phone_No}</TableCell>
                </TableRow>
            </TableBody>
            </Table>
            </TableRow>
    )
}

export default AddressInfoTable;